// useBackLink.js
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { match } from 'path-to-regexp'

const backMap = [
  { pattern: '/account-admin', prev: '' },
  { pattern: '/account/:name', prev: '' },
  { pattern: '/account/edit/:name', prev: '/account/:name' },
  { pattern: '/account/edit/:name', prev: '/account/:name' },
  { pattern: '/admin/add-account', prev: '/account-admin' },
  { pattern: '/account-admin/:name', prev: '/account-admin' },
  { pattern: '/account/edit/:name/:productId', prev: '/account-admin/:name' },
  // { pattern: '/account-admin/edit/:name', prev: '/account-admin' },

  // { pattern: '/account/products/:account', prev: '/account-admin' },
  // { pattern: '/users/create-user', prev: '/account-admin' },
  // { pattern: '/account/products/:account/:productConfig', prev: '/account/products/:account' },

  // now for products
  { pattern: '/products/add-product-template', prev: '/products' },
  { pattern: '/products/edit/:id', prev: '/products' },
  { pattern: '/products/view/:id', prev: '/products' },
  { pattern: '/company-accounts/create-user-admin', prev: '/company-accounts' },

  // …add as many as you need
]

export function useBackLink() {
  const route = useRoute()

  const backLink = computed(() => {
    const current = route.path
    for (const entry of backMap) {
      const matcher = match(entry.pattern, { decode: decodeURIComponent })
      const m = matcher(current)
      if (m) {
        // substitute any params into prev
        let href = entry.prev
        Object.entries(m.params).forEach(([k, v]) => {
          href = href.replace(`:${k}`, v)
        })
        return href || null
      }
    }
    return null
  })

  return { backLink }
}
